export enum ResendConfirmationEmailMessages {
  resendConfirmationEmailRequiredEmail = "resendConfirmationEmail.required.email",
  resendConfirmationEmailInvalidEmail = "resendConfirmationEmail.invalid.email",
  resendConfirmationEmailTitlePage = "resendConfirmationEmail.title.page",
  resendConfirmationEmailLabel = "resendConfirmationEmail.email.label",
  resendConfirmationEmailButton = "resendConfirmationEmail.button"
}

export interface TranslationResendConfirmationEmailMessages {
  [ResendConfirmationEmailMessages.resendConfirmationEmailRequiredEmail]: string;
  [ResendConfirmationEmailMessages.resendConfirmationEmailInvalidEmail]: string;
  [ResendConfirmationEmailMessages.resendConfirmationEmailTitlePage]: string;
  [ResendConfirmationEmailMessages.resendConfirmationEmailLabel]: string;
  [ResendConfirmationEmailMessages.resendConfirmationEmailButton]: string;
}